<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectPortal, type SelectPortalProps, useForwardProps } from "reka-ui";

const props = withDefaults(defineProps<SelectPortalProps>(), {});
// Only the set props; typed as such (see HPixSelectArrow).
const forwarded = useForwardProps(props) as ComputedRef<SelectPortalProps>;
</script>

<template>
  <SelectPortal v-bind="forwarded">
    <slot />
  </SelectPortal>
</template>
